import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface UserItem {
  _id: string;
  first_name?: string;
  last_name?: string;
  email?: string;
  phone?: string;
}

interface UsersState {
  loading: boolean;
  data: any;
  error: any;
}

const initialState: UsersState = {
  loading: false,
  data: null,
  error: null,
};

const UsersSlicer = createSlice({
  name: "Users",
  initialState,
  reducers: {
    getUsers(state) {
      state.loading = true;
      state.error = null;
    },
    successGetUsers(state, action: PayloadAction<any>) {
      state.loading = false;
      state.data = action.payload;
      state.error = null;
    },
    failureGetUsers(state, action: PayloadAction<any>) {
      state.loading = false;
      state.error = action.payload;
    },
    clearUsersState(state) {
      state.loading = false;
      state.data = null;
      state.error = null;
    },
  },
});

export const {
  getUsers,
  successGetUsers,
  failureGetUsers,
  clearUsersState,
} = UsersSlicer.actions;

export default UsersSlicer.reducer;

